"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LArtDeVivreEnUzege() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222221" id="ihre-experten-für-sichere-bäume" className="relative w-full h-[100dvh] min-h-[600px] flex flex-col items-center justify-center overflow-hidden dark bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://baumpflege-straesser.de/wp-content/uploads/2026/05/ChatGPT-Image-5.-Mai-2026-12_15_12.jpg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642178/img/ChatGPT-Image-5.-Mai-2026-12_15_12.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642178/img/ChatGPT-Image-5.-Mai-2026-12_15_12.png-wvc-sizes" alt="Professionelle Baumpflege Banner" className="absolute inset-0 w-full h-full object-cover scale-105 transition-transform duration-[20000ms] ease-linear hover:scale-100" loading="lazy" decoding="async" />
      </div>

      {}
      <div ref={ref} className="relative z-20 w-full max-w-7xl px-6 flex flex-col justify-start items-center gap-8 overflow-hidden !h-[480px] md:px-12 md:items-start">
        
        
        {}
        <div className={`flex flex-col transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
          <span className="font-serif italic text-white/90 drop-shadow-xl !text-7xl">Baumpflege Straesser</span>
        </div>

        {}
        <div className={`flex flex-col transition-all duration-1000 delay-300 ease-out transform ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
          <span className="font-serif italic text-3xl md:text-5xl lg:text-6xl text-white/90 drop-shadow-xl"><br />Präzise. Sicher.<br />Nachhaltig.</span>
          <p className="mt-4 text-white/80 font-sans text-lg md:text-xl max-w-xs drop-shadow-md"><br />Professionelle Baumpflege in Hamburg, Ahrensburg &amp; Schleswig Holstein.</p>
        </div>
      </div>

      {}
      <div className="absolute bottom-12 md:bottom-16 z-20 flex flex-col items-center animate-bounce">
        <Link to="#footer">
          <Button size="lg" className="bg-destructive text-white hover:bg-destructive/90 rounded-lg px-8 py-6 text-lg font-default shadow-xl transition-transform hover:scale-105">
            Jetzt anrufen
          </Button>
        </Link>
      </div>
    </section>;
}